/**
 * The six-hue flavor palette. Each name maps to a token trio in
 * `styles/global.css`:  --color-flavor-<name>, -<name>-soft, -<name>-ink.
 *
 * Shared by Blob, Sticker, Tile, Badge and FlavorPicker so a feature picks a
 * flavor by name and every surface tints consistently.
 */
export const FLAVORS = ['citron', 'peach', 'berry', 'grape', 'lychee', 'melon'] as const;

export type Flavor = (typeof FLAVORS)[number];

/** Tailwind classes for a flavor's three token shades. */
export const flavorClass = {
  citron: {
    bg: 'bg-flavor-citron',
    soft: 'bg-flavor-citron-soft',
    text: 'text-flavor-citron-ink',
    border: 'border-flavor-citron',
  },
  peach: {
    bg: 'bg-flavor-peach',
    soft: 'bg-flavor-peach-soft',
    text: 'text-flavor-peach-ink',
    border: 'border-flavor-peach',
  },
  berry: {
    bg: 'bg-flavor-berry',
    soft: 'bg-flavor-berry-soft',
    text: 'text-flavor-berry-ink',
    border: 'border-flavor-berry',
  },
  grape: {
    bg: 'bg-flavor-grape',
    soft: 'bg-flavor-grape-soft',
    text: 'text-flavor-grape-ink',
    border: 'border-flavor-grape',
  },
  lychee: {
    bg: 'bg-flavor-lychee',
    soft: 'bg-flavor-lychee-soft',
    text: 'text-flavor-lychee-ink',
    border: 'border-flavor-lychee',
  },
  melon: {
    bg: 'bg-flavor-melon',
    soft: 'bg-flavor-melon-soft',
    text: 'text-flavor-melon-ink',
    border: 'border-flavor-melon',
  },
} satisfies Record<Flavor, { bg: string; soft: string; text: string; border: string }>;

/** The raw CSS var reference for a flavor (for inline styles / gradients). */
export function flavorVar(flavor: Flavor, shade?: 'soft' | 'ink'): string {
  return `var(--color-flavor-${flavor}${shade ? `-${shade}` : ''})`;
}
